import React from 'react'

const CredentialCheck = ({...r}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" {...r}>
      <path
        fill="#00033A"
        d="M32.97 8.322a3.375 3.375 0 00-3.376-3.375H13.482a3.376 3.376 0 00-3.376 3.375L10.087 15h1.329l.024-6.693a2.05 2.05 0 012.05-2.047l1.864.002c.394 0 .54 0 .564.5.023.518.38.836.863.988.081.025 2.43.04 4.78.042h1c1.974-.002 3.71-.013 3.78-.034.482-.152.84-.47.865-.987.024-.5.17-.5.563-.5h1.848a2.05 2.05 0 012.046 2.05L31.65 17h1.31l.011-8.678zm-3.472 39.526a3.375 3.375 0 003.376-3.375L32.907 36h-1.324l-.043 8.44a2.046 2.046 0 01-2.049 2.046l-16.126-.012a2.049 2.049 0 01-2.047-2.049L11.35 35h-1.315l-.025 9.473a3.377 3.377 0 003.377 3.375h16.11z"
      ></path>
      <path
        stroke="#126FFF"
        strokeWidth="1.6"
        d="M32.192 16.842l-20.267-2.038c-2.175-.219-4.124 1.322-4.344 3.435l-1.255 12.02c-.201 1.915 1.087 3.653 2.95 4.124.192.049.39.084.593.105l20.27 2.038c2.173.219 4.123-1.323 4.342-3.436l1.256-12.02c.2-1.916-1.088-3.654-2.95-4.125a3.955 3.955 0 00-.595-.103z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#126FFF"
        fillRule="evenodd"
        stroke="#126FFF"
        strokeWidth="0.3"
        d="M29.266 25.827a.573.573 0 01-.481-.678 1.775 1.775 0 00-.27-1.335 1.756 1.756 0 00-1.131-.751 1.78 1.78 0 00-2.079 1.412.586.586 0 01-.67.455.572.572 0 01-.45-.673c.306-1.586 1.84-2.634 3.417-2.322a2.89 2.89 0 011.86 1.236 2.92 2.92 0 01.444 2.197.573.573 0 01-.64.46zM17.731 24.36a.573.573 0 01-.481-.678 1.775 1.775 0 00-.27-1.336 1.756 1.756 0 00-1.132-.751 1.788 1.788 0 00-2.078 1.413.577.577 0 01-.67.454.572.572 0 01-.45-.672c.306-1.587 1.836-2.635 3.417-2.322a2.89 2.89 0 011.86 1.235 2.92 2.92 0 01.444 2.197.573.573 0 01-.64.46zm2.915 5.637a2.804 2.804 0 01-2.349-2.144.57.57 0 111.11-.27 1.672 1.672 0 002.984.596.57.57 0 11.925.675 2.81 2.81 0 01-2.67 1.143z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#126FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.6"
        d="M37.433 14.458l2.167-2.335m-.219 5.619l4.644-2.437m-4.254 6.185l2.893.303"
      ></path>
    </svg>
  )
}

export default CredentialCheck